// extracted by css-extract-rspack-plugin
export default {"root":"root-N7htXO","disabled":"disabled-uGKyM0","value":"value-kFYA5u","placeholder":"placeholder-mWCUAX text-sm","option":"option-NIK68y","optionText":"optionText-tc4jDn"};